<div class="component-container">
    <nirby-image-selector
        [ngModel]="null"
        (ngModelChange)="onNewUrl($event?.lastUrl)"
    ></nirby-image-selector>
</div>
